import type { InputType } from 'config'
import { useRef, useState } from 'react'
import { RenderInput } from 'utils/RenderInput'

import { ReviewFormPlaceholders } from './placeholders'

export const ReviewFormPlaceholderEditor = ({
  inputs,
  onChange,
}: {
  inputs: Record<string, InputType>
  onChange: (key: string, value: any) => void
}) => {
  const activeInputRef = useRef<HTMLInputElement | HTMLTextAreaElement | null>(null)
  const [cursorPos, setCursorPos] = useState(0)
  const [focusKey, setFocusKey] = useState('description')

  const handleFocus = (event: any, key: string) => {
    if (key !== 'title' && key !== 'description') return
    activeInputRef.current = event.target
    setCursorPos(event.target.selectionStart || 0)
    setFocusKey(key)
  }

  const handleCursorChange = (event: any) => {
    if (typeof event?.target?.selectionStart === 'number') setCursorPos(event.target.selectionStart)
  }

  const insertTextAtCursor = (text: string) => {
    const input = activeInputRef.current
    const value = String(inputs[focusKey]?.value || '')
    if (!input) {
      onChange(focusKey, value + text)
      return
    }
    const next = cursorPos + text.length
    onChange(focusKey, value.substring(0, cursorPos) + text + value.substring(cursorPos))
    setTimeout(() => {
      input.focus()
      input.setSelectionRange(next, next)
      setCursorPos(next)
    }, 0)
  }

  return (
    <>
      <div>
        <p className="text-sm font-medium mb-1">Placeholders</p>
        <p className="text-xs text-gray-500 mb-2">
          Click a name to insert it into the title or description. <code>{'{{CompanyName}}'}</code> is this portal's
          legal name. The same names as the loan term sheet work here too.
        </p>
        <div className="p-3 border rounded-md max-h-40 overflow-y-auto">
          <div className="flex gap-x-1 gap-y-2 flex-wrap">
            {ReviewFormPlaceholders.map((item) => (
              <pre key={item} className="w-[220px] text-sm">
                <span className="cursor-pointer hover:underline" onClick={() => insertTextAtCursor(`{{${item}}}`)}>
                  {item}
                </span>
              </pre>
            ))}
          </div>
        </div>
      </div>
      {Object.keys(inputs).map((key) => (
        <div className="input" key={key}>
          <RenderInput
            input={inputs[key]}
            Key={key}
            onChange={onChange}
            onFocus={handleFocus}
            onKeyUp={handleCursorChange}
            onClick={handleCursorChange}
          />
        </div>
      ))}
    </>
  )
}
